export default "__VITE_ASSET__lcXXt$XE__"